<template>
  <v-card>
    <v-card-title>
      {{ $t('massSignComponent.title') }}
    </v-card-title>
    <v-card-text>
      <v-select
          :label="$t('massSignComponent.selectLabel')"
          :items="certificateDropdownOptions"
          v-model="certificate"
      >
        <template v-slot:no-data>
          <h5 class="text-center">{{ $t('massSignComponent.noKeys') }}</h5>
        </template>

        <template v-slot:item="{item}">
          <v-card flat width="100%" class="mb-2">
            <v-card-text class="pa-0">
              <div class="subtitle-1">
                <span class="font-weight-light">{{ $t('massSignComponent.itemLabels.owner') }}</span> <span
                  class="font-weight-bold float-right">{{ item.value.issuedPerson.toUpperCase() }}</span><br>
                <span class="font-weight-light">{{ $t('massSignComponent.itemLabels.organization') }}</span> <span
                  class="font-weight-bold float-right">{{ item.text.toUpperCase() }}</span> <br>
                <span class="font-weight-light">{{ $t('massSignComponent.itemLabels.tin') }}</span> <span class="font-weight-bold float-right">{{ item.value.innNumber }}</span>
                <br>
                <span class="font-weight-light">{{ $t('massSignComponent.itemLabels.validUntil') }}</span> <span
                  class="font-weight-bold float-right">{{ item.value.validEndDate.toLocaleDateString() }}</span>
              </div>
            </v-card-text>

            <v-divider class="my-1" color="yellow"/>
          </v-card>
        </template>
      </v-select>
    </v-card-text>

    <v-card-actions>
      <v-btn color="primary" @click="onCancel" :disabled="disable">{{ $t('common.actions.cancel') }}</v-btn>
      <v-spacer/>
      <v-btn color="primary" :disabled="$v.$invalid || disable" @click="onSignClicked">{{ $t('massSignComponent.actions.sign') }}</v-btn>
    </v-card-actions>

    <v-snackbar v-model="failDialog"
                :timeout="10000"
                :top="true"
                color="error"
    >
      {{ $t('massSignComponent.messages.signError') }}
    </v-snackbar>
  </v-card>
</template>

<script>
import EImzo from '../plugins/eimzo'
import _ from 'underscore'
import {required} from 'vuelidate/lib/validators'

export default {
  name: "MassSignComponent",
  props: {
    hashCode: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      certificate: null,
      failDialog: false,
    }
  },
  validations: {
    certificate: {
      required
    }
  },
  computed: {
    certificates() {
      return EImzo.certificates;
    },
    activeCertificates() {
      const nowTime = (new Date()).getTime();

      return _.filter(this.certificates, certificate => {
        const certificateEndTime = certificate.validEndDate.getTime();

        return certificateEndTime > nowTime;
      });
    },
    certificateDropdownOptions() {
      return _.map(this.activeCertificates, activeCertificate => {
        return {
          text: activeCertificate.companyName || activeCertificate.issuedPerson,
          value: activeCertificate
        };
      });
    }
  },
  methods: {
    showFailDialog() {
      this.failDialog = true
    },
    onSignClicked() {
      this.$emit('sign-clicked', this.certificate)
    },
    onCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>